"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ServerRuntimeClient = void 0;

var _baseclient = require("./baseclient.js");

var _checkin = require("./checkin.js");

var _currentScopes = require("./currentScopes.js");

var _debugBuild = require("./debug-build.js");

var _sessionflusher = require("./sessionflusher.js");

var _errors = require("./tracing/errors.js");

require("./utils-hoist/debug-build.js");

var _logger = require("./utils-hoist/logger.js");

require("./utils-hoist/time.js");

var _spanOnScope = require("./utils/spanOnScope.js");

var _spanUtils = require("./utils/spanUtils.js");

var _misc = require("./utils-hoist/misc.js");

var _syncpromise = require("./utils-hoist/syncpromise.js");

var _eventbuilder = require("./utils-hoist/eventbuilder.js");

var _dynamicSamplingContext = require("./tracing/dynamicSamplingContext.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * The Sentry Server Runtime Client SDK.
 */
class ServerRuntimeClient extends _baseclient.BaseClient {
  // eslint-disable-next-line deprecation/deprecation

  /**
   * Creates a new Edge SDK instance.
   * @param options Configuration options for this SDK.
   */
  constructor(options) {
    // Server clients always support tracing
    (0, _errors.registerSpanErrorInstrumentation)();
    super(options);
  }
  /**
   * @inheritDoc
   */


  eventFromException(exception, hint) {
    const event = (0, _eventbuilder.eventFromUnknownInput)(this, this._options.stackParser, exception, hint);
    event.level = 'error';
    return (0, _syncpromise.resolvedSyncPromise)(event);
  }
  /**
   * @inheritDoc
   */


  eventFromMessage(message, level = 'info', hint) {
    return (0, _syncpromise.resolvedSyncPromise)((0, _eventbuilder.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace));
  }
  /**
   * @inheritDoc
   */


  captureException(exception, hint, scope) {
    // Check if `_sessionFlusher` exists because it is initialized (defined) only when the `autoSessionTracking` is enabled.
    // The expectation is that session aggregates are only sent when `autoSessionTracking` is enabled.
    // TODO(v9): Our goal in the future is to not have the `autoSessionTracking` option and instead rely on integrations doing the creation and sending of sessions. We will not have a central kill-switch for sessions.
    // TODO(v9): This should move into the httpIntegration.
    // eslint-disable-next-line deprecation/deprecation
    if (this._options.autoSessionTracking && this._sessionFlusher) {
      // eslint-disable-next-line deprecation/deprecation
      const requestSession = (0, _currentScopes.getIsolationScope)().getRequestSession(); // Necessary checks to ensure this is code block is executed only within a request
      // Should override the status only if `requestSession.status` is `Ok`, which is its initial stage

      if (requestSession && requestSession.status === 'ok') {
        requestSession.status = 'errored';
      }
    }

    return super.captureException(exception, hint, scope);
  }
  /**
   * @inheritDoc
   */


  captureEvent(event, hint, scope) {
    // Check if `_sessionFlusher` exists because it is initialized only when the `autoSessionTracking` is enabled.
    // The expectation is that session aggregates are only sent when `autoSessionTracking` is enabled.
    // TODO(v9): Our goal in the future is to not have the `autoSessionTracking` option and instead rely on integrations doing the creation and sending of sessions. We will not have a central kill-switch for sessions.
    // TODO(v9): This should move into the httpIntegration.
    // eslint-disable-next-line deprecation/deprecation
    if (this._options.autoSessionTracking && this._sessionFlusher) {
      const eventType = event.type || 'exception';
      const isException = eventType === 'exception' && event.exception && event.exception.values && event.exception.values.length > 0; // If the event is of type Exception, then a request session should be captured

      if (isException) {
        // eslint-disable-next-line deprecation/deprecation
        const requestSession = (0, _currentScopes.getIsolationScope)().getRequestSession(); // Ensure that this is happening within the bounds of a request, and make sure not to override
        // Session Status if Errored / Crashed

        if (requestSession && requestSession.status === 'ok') {
          requestSession.status = 'errored';
        }
      }
    }

    return super.captureEvent(event, hint, scope);
  }
  /**
   *
   * @inheritdoc
   */


  close(timeout) {
    if (this._sessionFlusher) {
      this._sessionFlusher.close();
    }

    return super.close(timeout);
  }
  /**
   * Initializes an instance of SessionFlusher on the client which will aggregate and periodically flush session data.
   *
   * NOTICE: This method will implicitly create an interval that is periodically called.
   * To clean up this resources, call `.close()` when you no longer intend to use the client.
   * Not doing so will result in a memory leak.
   */


  initSessionFlusher() {
    const _this$_options = this._options,
          release = _this$_options.release,
          environment = _this$_options.environment;

    if (!release) {
      _debugBuild.DEBUG_BUILD && _logger.logger.warn('Cannot initialize an instance of SessionFlusher if no release is provided!');
    } else {
      // eslint-disable-next-line deprecation/deprecation
      this._sessionFlusher = new _sessionflusher.SessionFlusher(this, {
        release,
        environment
      });
    }
  }
  /**
   * Create a cron monitor check in and send it to Sentry.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   */


  captureCheckIn(checkIn, monitorConfig, scope) {
    const id = 'checkInId' in checkIn && checkIn.checkInId ? checkIn.checkInId : (0, _misc.uuid4)();

    if (!this._isEnabled()) {
      _debugBuild.DEBUG_BUILD && _logger.logger.warn('SDK not enabled, will not capture checkin.');
      return id;
    }

    const options = this.getOptions();
    const release = options.release,
          environment = options.environment,
          tunnel = options.tunnel;
    const serializedCheckIn = {
      check_in_id: id,
      monitor_slug: checkIn.monitorSlug,
      status: checkIn.status,
      release,
      environment
    };

    if ('duration' in checkIn) {
      serializedCheckIn.duration = checkIn.duration;
    }

    if (monitorConfig) {
      serializedCheckIn.monitor_config = {
        schedule: monitorConfig.schedule,
        checkin_margin: monitorConfig.checkinMargin,
        max_runtime: monitorConfig.maxRuntime,
        timezone: monitorConfig.timezone,
        failure_issue_threshold: monitorConfig.failureIssueThreshold,
        recovery_threshold: monitorConfig.recoveryThreshold
      };
    }

    const _this$_getTraceInfoFr = this._getTraceInfoFromScope(scope),
          _this$_getTraceInfoFr2 = _slicedToArray(_this$_getTraceInfoFr, 2),
          dynamicSamplingContext = _this$_getTraceInfoFr2[0],
          traceContext = _this$_getTraceInfoFr2[1];

    if (traceContext) {
      serializedCheckIn.contexts = {
        trace: traceContext
      };
    }

    const envelope = (0, _checkin.createCheckInEnvelope)(serializedCheckIn, dynamicSamplingContext, this.getSdkMetadata(), tunnel, this.getDsn());
    _debugBuild.DEBUG_BUILD && _logger.logger.info('Sending checkin:', checkIn.monitorSlug, checkIn.status); // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises

    this.sendEnvelope(envelope);
    return id;
  }
  /**
   * Method responsible for capturing/ending a request session by calling `incrementSessionStatusCount` to increment
   * appropriate session aggregates bucket
   *
   * @deprecated This method should not be used or extended. It's functionality will move into the `httpIntegration` and not be part of any public API.
   */


  _captureRequestSession() {
    if (!this._sessionFlusher) {
      _debugBuild.DEBUG_BUILD && _logger.logger.warn('Discarded request mode session because autoSessionTracking option was disabled');
    } else {
      this._sessionFlusher.incrementSessionStatusCount();
    }
  }
  /**
   * @inheritDoc
   */


  _prepareEvent(event, hint, scope, isolationScope) {
    if (this._options.platform) {
      event.platform = event.platform || this._options.platform;
    }

    if (this._options.runtime) {
      event.contexts = _objectSpread(_objectSpread({}, event.contexts), {}, {
        runtime: (event.contexts || {}).runtime || this._options.runtime
      });
    }

    if (this._options.serverName) {
      event.server_name = event.server_name || this._options.serverName;
    }

    return super._prepareEvent(event, hint, scope, isolationScope);
  }
  /** Extract trace information from scope */


  _getTraceInfoFromScope(scope) {
    if (!scope) {
      return [undefined, undefined];
    }

    const span = (0, _spanOnScope._getSpanForScope)(scope);
    const traceContext = span ? (0, _spanUtils.spanToTraceContext)(span) : (0, _currentScopes.getTraceContextFromScope)(scope);
    const dynamicSamplingContext = span ? (0, _dynamicSamplingContext.getDynamicSamplingContextFromSpan)(span) : (0, _dynamicSamplingContext.getDynamicSamplingContextFromScope)(this, scope);
    return [dynamicSamplingContext, traceContext];
  }

}

exports.ServerRuntimeClient = ServerRuntimeClient;